<template>
    <div>
        <div class="flex mb-1">
            <div class="w-full flex justify-between items-center">
                <h4>Posición geográfica</h4>
            </div>
            <div v-if="enabled" class="w-full">
                <p>
                    Recuerda debes indicarnos tu ubicación haciendo click en el
                    mapa.
                </p>
            </div>
        </div>
        <div v-if="enabled" class="flex items-center mb-4">
            <custom-switch v-model="manualEntry" />
            <label class="ml-2">Ingreso manual de coordenadas</label>
        </div>
        <div v-show="showMessageCoors" class="flex w-full">
            <span class="text-danger">Debes ubicar tu dirección</span>
        </div>
        <div v-if="manualEntry" class="flex flex-wrap">
            <div
                class="card xl:w-10/12 lg:w-10/12 w-11/12 mx-auto border rounded-lg p-4"
            >
                <div class="flex flex-col space-y-2">
                    <input
                        v-model="lat"
                        type="number"
                        step="0.0000001"
                        placeholder="Latitud"
                        class="border rounded p-2"
                        @input="onManualChange"
                    />
                    <input
                        v-model="lon"
                        type="number"
                        step="0.0000001"
                        placeholder="Longitud"
                        class="border rounded p-2"
                        @input="onManualChange"
                    />
                </div>
            </div>
        </div>
        <div v-else class="flex flex-wrap">
            <div
                class="card xl:w-10/12 lg:w-10/12 w-11/12 mx-auto map-template border rounded-lg p-0"
                :class="
                    showMessageCoors ? 'border-danger' : 'border-theme-success'
                "
            >
                <l-map ref="mainMap" @ready="loadMap()"></l-map>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LocationSelector",
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            default: () => ({ latitude: 4.63082, longitude: -74.15035 }),
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        showMessageCoors: false,
        lat: 4.63082,
        lon: -74.15035,
        introCoors: false,
        manualEntry: false
    }),
    computed: {
        validLon() {
            return Number(this.lon) > -180 && Number(this.lon) < 180;
        },
        validLat() {
            return Number(this.lat) > -90 && Number(this.lat) < 90;
        }
    },
    watch: {
        itemCurrent(value) {
            if ("latitude" in value) {
                this.lat = value.latitude;
                this.lon = value.longitude;
                if (!this.manualEntry) {
                    this.$map.removeAllMarkers();
                    this.$map.addMarker(
                        "1",
                        [this.lat, this.lon],
                        "<p>🏫 Dir</p>"
                    );
                }
            }
        },
        manualEntry(newVal) {
            if (!newVal && this.$refs.mainMap) {
                this.$nextTick(() => {
                    this.loadMap();
                });
            }
        }
    },
    methods: {
        loadMap() {
            this.$map.init(
                this.$refs.mainMap.mapObject,
                this.onClickMap,
                this.$businessName
            );
            if ("latitude" in this.itemCurrent) {
                this.lat = this.itemCurrent.latitude;
                this.lon = this.itemCurrent.longitude;
                this.$map.addMarker("1", [this.lat, this.lon], "<p>🏫 Dir</p>");
            }
            this.$map.setView([this.lat, this.lon]);
            this.enableMap = false;
        },
        onClickMap(event) {
            if (!this.enabled) {
                return;
            }
            this.introCoors = true;
            this.showMessageCoors = false;
            this.$emit("change", {
                latitude: Number(Number(event.latlng.lat).toFixed(7)),
                longitude: Number(Number(event.latlng.lng).toFixed(7))
            });
        },
        onManualChange() {
            if (this.validLat && this.validLon) {
                this.showMessageCoors = false;
                this.introCoors = true;
                this.$emit("change", {
                    latitude: Number(this.lat),
                    longitude: Number(this.lon)
                });
            } else {
                this.showMessageCoors = true;
            }
        }
    }
};
</script>
